import { FunctionComponent } from 'react';
import Console from '@playground/SQL/components/Console';
import { usePyodide } from '@playground/SQL/hooks/usePyodide';

const Terminal: FunctionComponent = () => {
  const { pyodide } = usePyodide();

  return (
    <div className="rounded overflow-hidden h-full flex flex-col">
      <Console logs={pyodide.logs} reset={() => pyodide.clearLogs()} />
    </div>
  );
};

export default Terminal;
